import { label } from "./Attributes";

export default function Preview({ command }) {
    return (
        <span className="ms-3">
            <span className="me-2">{label}</span>
            <code className="me-2">
                {command.settings.z || 0}
                {"m"}
            </code>
        </span>
    );
}
